import getValueOffPercent from 'lib/getValueOffPercent'
import {
  BookmarkDatesAndOccupancy,
  PriceDisplayType,
  SavedHotelData,
} from 'tripPlanner/types/tripItem'
import {
  CreateHotelRequestBody,
  getCheckInCheckOutOccupancy,
  getPlaceFromOffer,
} from 'tripPlanner/utils/itemConversions/common'

interface Params {
  offer: App.Offer | App.OfferSummary
  datesAndGuests: BookmarkDatesAndOccupancy
  currentRegionCode: string
  currencyCode: string
  price?: number
  value?: number
  taxExclusivePricing?: boolean
  roomTypeId?: string
  templateId?: string
  templateItemId?: string
}

export function createLEOfferItemPayload({
  offer,
  datesAndGuests,
  currentRegionCode,
  currencyCode,
  price,
  value,
  taxExclusivePricing,
  roomTypeId,
  templateId,
  templateItemId,
}: Params): CreateHotelRequestBody {
  if (offer.type === 'tour' || offer.type === 'bundle_and_save') {
    // Just to satisfy Typescript. This shouldn't ever happen.
    throw new Error('Invalid offer type')
  }

  const discountPercent =
    typeof price === 'number' && typeof value === 'number'
      ? getValueOffPercent(value, price)
      : undefined

  // When we do not have any room option for selected dates/guests,
  // we won't get a price.
  // In such cases, we do not want to save dates/guests in the trip item
  const datesAndOccupancy =
    typeof price === 'number' ? getCheckInCheckOutOccupancy(datesAndGuests) : {}

  let priceDisplayType: PriceDisplayType | undefined = undefined
  if (typeof taxExclusivePricing === 'boolean') {
    priceDisplayType = taxExclusivePricing
      ? 'taxesAndFeesExclusive'
      : 'taxesAndFeesInclusive'
  }

  const savedHotelData: SavedHotelData = {
    regionCode: currentRegionCode,
    offerType: offer.type,
    currencyCode,
    offerId: offer.id,
    durationInDays: datesAndGuests.durationInDays,
    price,
    value,
    discountPercent,
    priceDisplayType,
    roomTypeId,
    roomTypeName: roomTypeId
      ? offer.packages.find((p) => p.roomType?.id === roomTypeId)?.roomType
          ?.name
      : undefined,
    ...datesAndOccupancy,
  }

  const payload: CreateHotelRequestBody = {
    type: 'HOTEL',
    isBooked: false,
    sourceType: 'LE_Hotel',
    place: getPlaceFromOffer(
      offer,
      datesAndOccupancy.checkIn,
      datesAndOccupancy.checkOut,
    ),
    code: offer.id,
    subCode: roomTypeId,
    savedItemData: savedHotelData,
    templateId,
    templateItemId,
  }

  return payload
}
